import { useState } from "react";
import { X, Loader2, CheckCircle2 } from "lucide-react";
import { api, formatError } from "@/lib/api";

const inputCls =
  "w-full rounded-lg border border-gold/20 bg-ink px-4 py-3 text-ivory placeholder:text-stone2/60 outline-none transition-colors focus:border-gold";

const PasswordModal = ({ onClose }) => {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (next.length < 6) return setErr("La nueva clave debe tener al menos 6 caracteres.");
    if (next !== confirm) return setErr("La nueva clave y su confirmación no coinciden.");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      setDone(true);
    } catch (error) {
      setErr(formatError(error.response?.data?.detail) || "No se pudo cambiar la clave.");
    }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-end justify-center bg-ink/85 backdrop-blur-sm sm:items-center sm:p-6" data-testid="password-modal">
      <div className="w-full max-w-md rounded-t-2xl border border-gold/25 bg-ink2 p-6 shadow-2xl sm:rounded-2xl md:p-8">
        <div className="flex items-center justify-between">
          <h3 className="font-serif text-2xl text-ivory">Cambiar mi clave</h3>
          <button onClick={onClose} data-testid="password-close-button" aria-label="Cerrar" className="rounded-full border border-gold/30 p-2 text-gold">
            <X size={18} />
          </button>
        </div>

        {done ? (
          <div className="py-6 text-center" data-testid="password-success-panel">
            <CheckCircle2 className="mx-auto text-wa" size={44} />
            <p className="mt-4 font-medium text-ivory">¡Clave actualizada!</p>
            <p className="mt-2 text-sm text-stone2">
              Guárdala en un lugar seguro. Tu sesión actual sigue abierta; la próxima vez entra con la clave nueva.
            </p>
            <button
              onClick={onClose}
              data-testid="password-done-close-button"
              className="btn-gold-metallic mt-6 rounded-full px-8 py-3 text-xs font-bold uppercase tracking-[0.18em] text-ink"
            >
              Entendido
            </button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="password-form">
            <input
              type="password"
              required
              placeholder="Clave actual"
              value={cur}
              onChange={(e) => setCur(e.target.value)}
              data-testid="password-current-input"
              className={inputCls}
            />
            <input
              type="password"
              required
              placeholder="Clave nueva (mínimo 6 caracteres)"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              data-testid="password-new-input"
              className={inputCls}
            />
            <input
              type="password"
              required
              placeholder="Repite la clave nueva"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              data-testid="password-confirm-input"
              className={inputCls}
            />
            {err && (
              <p className="text-sm text-red-400" data-testid="password-error">
                {err}
              </p>
            )}
            <button
              type="submit"
              disabled={saving}
              data-testid="password-save-button"
              className="btn-gold-metallic flex w-full items-center justify-center rounded-full py-3.5 text-xs font-bold uppercase tracking-[0.2em] text-ink disabled:opacity-60"
            >
              {saving ? <Loader2 size={16} className="animate-spin" /> : "Guardar clave nueva"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default PasswordModal;
